/**
 * Calcoli di prezzo condivisi fra tabella e dialog di "Analisi prezzi".
 *
 * Il cliente paga prezzo + spedizione: il confronto con la buybox si fa sui totali.
 * La nostra spedizione arriva dall'analisi (getPricing), perche' nel catalogo non c'e'.
 * Stessa regola di features/amazonprice/pricing.parser.js suggestedPrice.
 */

const toNumber = value => {
	if (value === undefined || value === null || value === '') {
		return null;
	}
	const parsed = Number(value);
	return Number.isFinite(parsed) ? parsed : null;
};

const round2 = value => Math.round(value * 100) / 100;

/** nostra spedizione nota dall'ultima analisi, altrimenti null */
export const ourShipping = item => {
	const analysis = (item && item.analysis) || {};
	return analysis.ourStatus === 'done' ? toNumber(analysis.ourShipping) : null;
};

/** nostro totale: prezzo attuale (anche dopo un aggiustamento) + spedizione Amazon */
export const ourTotal = item => {
	const price = toNumber(item && item.price);
	const shipping = ourShipping(item);
	return price === null || shipping === null ? null : round2(price + shipping);
};

/** buybox di altri e il nostro totale e' piu' alto del suo */
export const isMoreExpensive = item => {
	const analysis = (item && item.analysis) || {};
	const total = ourTotal(item);
	const landed = toNumber(analysis.buyBoxLandedPrice);
	return analysis.status === 'done' && !analysis.isOurs && total !== null && landed !== null && total > landed;
};

/**
 * Prezzo proposto: totale buybox - nostra spedizione - 0,01; senza la nostra
 * spedizione, prezzo buybox - 0,01. Null se non viene positivo.
 */
export const suggestedPrice = item => {
	const analysis = (item && item.analysis) || {};
	const landed = toNumber(analysis.buyBoxLandedPrice);
	const listing = toNumber(analysis.buyBoxListingPrice);
	const shipping = ourShipping(item);

	let value = null;
	if (landed !== null && shipping !== null) {
		value = round2(landed - shipping - 0.01);
	} else if (listing !== null) {
		value = round2(listing - 0.01);
	}
	return value !== null && value > 0 ? value : null;
};
